module.exports = __webpack_public_path__ + "img/20200409144033873.7f0520f8.png";